import { createContext, useContext } from 'react';
import { ContentValidator } from '../services/ContentEditorService';

export const ContentValidatorContext = createContext<ContentValidator | undefined>(undefined);

/**
 * Retrieves the `ContentValidator` to be injected into `ContentEditorService`.
 * This is a workaround since `ContentEditorService` can't directly import
 * the `validateContent()` function from legacy code, see {@link ContentValidatorProvider} for details
 */
export function useContentValidator(): ContentValidator {
  const validator = useContext(ContentValidatorContext);
  if (!validator) {
    throw new Error('useContentValidator must be used within a ContentValidatorContext.Provider');
  }
  return validator;
}
